let vimeoPlayer;

function HeroVideoBanner(){
    // Elements
    let container = $('.home.hero');
    let panels = container.find('.panels');

    // Variables
    let isMobile = $(window).width() <= 960;
    let videoID = isMobile ? container.data('video-mobile') : container.data('video-desktop');
    let height = isMobile ? container.outerHeight() : container.outerHeight() * 2.5;
    let width = isMobile ? height : height * 1.778;

    container.prepend('<div id="video" />');

    // Initialize Vimeo player once
    vimeoPlayer = new Vimeo('video', {
        id: videoID,
        muted: true,
        controls: false,
        loop: true
    });

    vimeoPlayer.play();

    let video = container.find('#video');

    if (isMobile && !panels.hasClass('slick-initialized')) {
        panels.slick({
            mobileFirst: true,
            arrows: false,
            autoplay: true,
            autoplaySpeed: 3000,
            dots: true
        });

        video.css('height', height);
        video.css('width', width);
    }

    // Resize logic
    $(window).resize($.debounce(200, function() {
        // Update elements and variables
        panels = container.find('.panels');
        isMobile = $(window).width() <= 960;
        videoID = isMobile ? container.data('video-mobile') : container.data('video-desktop');
        height = isMobile ? container.outerHeight() : '100vw';
        width = isMobile ? height : '177.78vw';

        if (isMobile && !panels.hasClass('slick-initialized')) {
            panels.slick({
                mobileFirst: true,
                arrows: false,
                autoplay: true,
                autoplaySpeed: 3000,
                dots: true
            });

            video.css('height', height);
            video.css('width', width);

            // Update video instead of reinitializing the player
            vimeoPlayer.loadVideo(videoID).then(() => {
                video.css('height', height);
                video.css('width', width);

                vimeoPlayer.play();
            });

        } else if (!isMobile && panels.hasClass('slick-initialized')) {
            panels.slick('unslick');

            // Update video instead of reinitializing the player
            vimeoPlayer.loadVideo(videoID).then(() => {
                video.css('height', height);
                video.css('width', width);

                vimeoPlayer.play();
            });
        }
    }));
}

$(() => {
    if($('.home.hero[data-video-mobile]').length) HeroVideoBanner();
});